import { memo } from "react";
import { Row } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { getInvoiceEffectiveStatus } from "@common/helpers/accrual-source";
import { InvoiceLineItem, InvoiceStatus } from "@common/types/invoice";
import { toDisplayDateOnly } from "@helpers/date";
import { PeriodLockIcon } from "@components/periodLock/PeriodLockIcon";
import { useIsEntityDateLocked } from "@components/periodLock/PeriodLockDatesProvider";

interface Props {
    row: Row<ViewTableFeatures, InvoiceLineItem>;
}

export const LockCell = memo(({ row }: Props) => {
    const invoice = row.original.invoice;
    const isDateLocked = useIsEntityDateLocked(
        invoice?.entityId ?? null,
        toDisplayDateOnly(invoice?.dateOnly),
    );
    const isDraft =
        invoice !== undefined &&
        getInvoiceEffectiveStatus(invoice) === InvoiceStatus.DRAFT;

    if (!isDateLocked || isDraft) {
        return null;
    }

    return (
        <PeriodLockIcon
            label="This invoice is locked."
            testId="invoice-line-item-lock"
        />
    );
});
LockCell.displayName = "LockCell";
